// extracted by mini-css-extract-plugin
export default {"loader":"LoadableImage__loader___xFoZe","loaderDots":"LoadableImage__loaderDots___XxK3A"};